module.exports = __webpack_public_path__ + "static/media/trash.f4d4e71c.svg";